<template>
  <div class="test-print">
    <iframe
        v-if="loaded"
        :src="iframe.src"
        :height="'100%'"
        :width="'100%'"
        type="application/pdf"
        frameborder="0"
    ></iframe>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loaded: false,
      iframe: {
        src: "https://wsb.bitville.dev/retail?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhY2NvdW50IjoidGVzdC1iZXRyYWRhci12Mi1jb20iLCJjdXJyZW5jeSI6IlpBUiIsImN1c3RvbWVySUQiOiIxMjAwMDAifQ.B2D46L7UTnLNUFGShW7FfGSyzxJwZ0RvP0Zp3yX9Juk&account=test-betradar-v2-com&printBet=yes&admin_user_id=32&is_retail=1&cashier_name=trungsbetcashier&cashier_name_for_printer=trungsbetcashier%20-%2032",
      }
    }
  },
  mounted() {
    this.loaded = true;
    window.addEventListener('message', this.receiveMessage)
  },
  methods: {
    receiveMessage (event) {
      console.log('event data from iframe', event.data)
    }
  },
  beforeUnmount () {
    window.removeEventListener('message', this.receiveMessage)
  }
}
</script>

<style scoped>
  .test-print {
    width: 100%;
    height: 100vh;
  }
</style>
